import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('GA Initialized');
    return true;
  } else {
    if (import.meta.env.DEV) {
      console.warn('GA not initialized - missing VITE_GA_MEASUREMENT_ID');
    }
    return false;
  }
};

// Track page views
export const trackPageView = (path: string) => {
  if (typeof window !== 'undefined' && GA_MEASUREMENT_ID) {
    ReactGA.send({ 
      hitType: 'pageview', 
      page: path,
      title: document.title
    });
  }
};

// Track events
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};
